import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component } from 'intact-vue-next';
import template from './step.vdt';
import { useConfigContext } from '../config';
var typeDefs = {
  title: String,
  index: Number
};
export var Step = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Step, _Component);
  function Step() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.config = useConfigContext();
    return _this;
  }
  return Step;
}(Component);
Step.template = template;
Step.typeDefs = typeDefs;